import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'

const getItems = ({ commit }, { page = 'fulfillments', params = {} }) => {
  commit(types.TOGGLE_LOADING)

  fetch(page, { params })
    .then((response) => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ITEMS, data.member)
      commit(types.SET_VIEW, data.view)
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
    })
}

export const reset = ({ commit }) => {
  commit(types.RESET)
}

export default getItems
